import React from 'react';
import { techIcons } from './TechStackIcons';

const techCategories = [
  {
    title: 'Frontend Development',
    techs: ['React', 'Angular', 'Vue.js', 'Tailwind CSS', 'Vite', 'Gatsby'],
  },
  {
    title: 'Backend Development',
    techs: ['Node.js', 'Express.js', 'Nest.js', 'Python', 'Django', 'Flask', '.NET / ASP.NET Core', 'GraphQL', 'Swagger', 'Java EE', 'Spring Boot', 'MongoDB', 'Firebase'],
  },
  {
    title: 'Database',
    techs: ['PostgreSQL', 'SQL Server', 'SQLite', 'MySQL'],
  },
  {
    title: 'DevOps / Cloud / Tools',
    techs: ['Docker', 'Kubernetes', 'GitHub / GitLab / Git SCM', 'Amazon Web Services (AWS)', 'Google Cloud', 'Azure', 'Splunk', 'Visual Studio / VS Code'],
  },
  {
    title: 'AI Tools for Productivity & Content',
    techs: ['Google Gemini', 'Power BI (with Copilot)', 'Tableau', 'Jasper AI'],
  },
  {
    title: 'Mobile App Development',
    techs: ['React Native', 'Flutter', 'Swift/Kotlin'],
  },
];

const TechStack = () => {
  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold text-center mb-2">TECHNOLOGY STACK</h2>
        <h3 className="text-xl text-center text-gray-600 mb-6">Empowering Tech Future</h3>
        <p className="max-w-3xl mx-auto text-center text-gray-600 mb-12">
          The company leverages modern technologies and frameworks to build scalable, secure, and high-performance digital solutions. Its tech stack is continuously updated to meet evolving industry standards and client needs.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {techCategories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md text-center">
              <h4 className="text-xl font-bold mb-4">{category.title}</h4>
              <div className="flex flex-wrap gap-4 justify-center">
                {category.techs.map((tech, i) => (
                  <div key={i} className="flex flex-col items-center">
                    <div className="text-4xl mb-2">{techIcons[tech] || tech}</div>
                    <span className="text-sm">{tech}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
